import { Component } from '@angular/core'
import { CommService } from './core/comm.service'
import { DevTenantService } from './core/dev-tenant.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  ie: boolean
  edge: boolean
  // DevTenantService is injected for its constructor side effect (parses
  // ?customer= and stashes it in sessionStorage on app load).
  constructor(private comm: CommService, _devTenant: DevTenantService) {
    if ((window.document as any).documentMode) {
      this.ie = true
    }
    if (/ Edge\//gm.test(navigator.userAgent)) {
      this.edge = true
    }
  }
}
